import { FC } from 'react';
import { CreditNotes } from 'components/CreditNotes';
import { Page } from 'layouts/Page';

export const CreditNotesPage: FC = () => {
	return (
		<Page title="Credit Notes – EAS Control Center">
			<CreditNotes />
		</Page>
	);
};
